import { CONTENT_CLASS } from '../styles';

/**
 * Plays the panel's enter transition, then calls `onOpened`.
 *
 * Classes are applied on the next frame so the browser paints the off-screen
 * position before the transition starts. Open does not wait for `animationend`:
 * the panel is already on screen, and a missed event would leave `open()`
 * pending. `durationMs` is the signal that the panel is fully open.
 *
 * @returns Cleanup that cancels the frame and the timer.
 */
export function playOpenAnimation(
  element: HTMLElement,
  durationMs: number,
  onOpened: () => void,
): () => void {
  let timeoutId: number | undefined;

  const animationId = requestAnimationFrame(() => {
    element.classList.add(...CONTENT_CLASS.show);
    element.style.setProperty('transform', '');

    timeoutId = window.setTimeout(onOpened, durationMs);
  });

  return () => {
    cancelAnimationFrame(animationId);

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
  };
}
